// Updated imports
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPurchaseComponent } from '../modal-purchase/modal-purchase.component';
import { BaseService } from 'src/app/services/base.service';
import { CANCEL_INVOICE } from 'src/app/constants/endpoint.const';
import { Subject, takeUntil } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ModalQrisComponent } from '../modal-qris/modal-qris.component';

@Component({
  standalone: false,
  selector: 'app-modal-unpaid',
  templateUrl: './modal-unpaid.component.html',
  styleUrls: ['./modal-unpaid.component.scss'],
})
export class ModalUnpaidComponent implements OnInit {
  destroy$ = new Subject();
  @Input() invoiceID: string = '';
  @Input() urlPayment: string = '';
  @Input() totalPrice: number = 0;
  @Input() packageId: number = 0;
  @Input() allowQris: boolean = true;
  @Input() isQris: boolean = true;
  @Input() expiredAt: string = '';
  @Input() qrCode: string = '';

  constructor(
    private route: Router,
    private BaseService: BaseService,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private message: NzMessageService
  ) {}

  ngOnInit(): void {}

  destroyModal(): void {
    this.activeModal.close();
  }

  cancelPayment() {
    const params = {
      invoice_id: this.invoiceID,
    };
    this.BaseService.putData(CANCEL_INVOICE, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.activeModal.close();
          this.message.create('success', 'Your payment has been canceled');
        },
        (err) => {
          this.message.create('error', err.data.errors);
        }
      );
  }

  payNow() {
    this.activeModal.close();
    if (this.isQris === true) {
      const modal = this.modalService.open(ModalQrisComponent, {
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        centered: true,
      });
      modal.componentInstance.invoiceId = this.invoiceID;
      modal.componentInstance.allowQris = this.allowQris;
      modal.componentInstance.totalPrice = this.totalPrice;
      modal.componentInstance.packageId = this.packageId;
      modal.componentInstance.expiredAt = this.expiredAt;
      modal.componentInstance.qrCode = this.qrCode;
    } else {
      window.open(this.urlPayment, '_blank');
      this.route.navigate(['subscriptions']);
      this.activeModal.close();
    }
  }

  back() {
    this.route.navigate(['subscriptions/upgrade-package']);
  }
}
